export const cardThemes = {
  courage: {
    name: '勇气',
    gradient: 'from-orange-400 to-red-500',
    glowColor: 'rgba(251, 146, 60, 0.5)'
  },
  dream: {
    name: '梦想',
    gradient: 'from-purple-400 to-pink-500',
    glowColor: 'rgba(192, 132, 252, 0.5)'
  },
  hope: {
    name: '希望',
    gradient: 'from-blue-400 to-cyan-500',
    glowColor: 'rgba(96, 165, 250, 0.5)'
  },
  wisdom: {
    name: '智慧',
    gradient: 'from-yellow-400 to-orange-500',
    glowColor: 'rgba(250, 204, 21, 0.5)'
  },
  love: {
    name: '爱',
    gradient: 'from-pink-400 to-rose-500',
    glowColor: 'rgba(244, 114, 182, 0.5)'
  },
  strength: {
    name: '力量',
    gradient: 'from-red-400 to-rose-500',
    glowColor: 'rgba(248, 113, 113, 0.5)'
  },
  peace: {
    name: '平和',
    gradient: 'from-green-400 to-emerald-500',
    glowColor: 'rgba(74, 222, 128, 0.5)'
  },
  growth: {
    name: '成长',
    gradient: 'from-teal-400 to-cyan-500',
    glowColor: 'rgba(45, 212, 191, 0.5)'
  },
  success: {
    name: '成功',
    gradient: 'from-indigo-400 to-violet-500',
    glowColor: 'rgba(129, 140, 248, 0.5)'
  }
};

export const cards = [
  {
    id: 1,
    title: '勇敢前行',
    content: '勇气不是没有恐惧，而是在恐惧面前依然选择前行。每一次突破都是成长的见证。',
    theme: 'courage',
    icon: '🦁'
  },
  {
    id: 2,
    title: '梦想启航',
    content: '心中有梦想，脚下就有力量。相信可能性，就能创造奇迹。',
    theme: 'dream',
    icon: '⭐'
  },
  {
    id: 3,
    title: '希望之光',
    content: '黑暗过后必有黎明。希望是支撑我们前行的最强大力量。',
    theme: 'hope',
    icon: '🌟'
  },
  {
    id: 4,
    title: '智慧之钥',
    content: '知识改变命运，智慧照亮人生。不断学习，成就更好的自己。',
    theme: 'wisdom',
    icon: '🔑'
  },
  {
    id: 5,
    title: '爱心传递',
    content: '爱是世界上最强大的力量。给予爱，收获爱，传递爱。',
    theme: 'love',
    icon: '💝'
  },
  {
    id: 6,
    title: '内心强大',
    content: '真正的力量来自内心。坚韧不拔，方能成就非凡。',
    theme: 'strength',
    icon: '💪'
  },
  {
    id: 7,
    title: '宁静致远',
    content: '平和的心态是成功的基石。心静如水，方能洞察一切。',
    theme: 'peace',
    icon: '🕊️'
  },
  {
    id: 8,
    title: '茁壮成长',
    content: '每一次经历都是成长的养分。向上生长，向阳而生。',
    theme: 'growth',
    icon: '🌱'
  },
  {
    id: 9,
    title: '突破自我',
    content: '最大的对手是自己。超越自我，才能触及更高的峰顶。',
    theme: 'success',
    icon: '🚀'
  },
  {
    id: 10,
    title: '坚持不懈',
    content: '成功源于坚持。只要不放弃，奇迹就会出现。',
    theme: 'courage',
    icon: '🏃'
  },
  {
    id: 11,
    title: '热情燃烧',
    content: '保持热情，让生活充满活力。热情是成功的燃料。',
    theme: 'dream',
    icon: '🔥'
  },
  {
    id: 12,
    title: '自信人生',
    content: '相信自己，你比想象中更强大。自信是成功的起点。',
    theme: 'hope',
    icon: '💫'
  },
  {
    id: 13,
    title: '创新思维',
    content: '打破常规思维，创造无限可能。创新推动进步。',
    theme: 'wisdom',
    icon: '💡'
  },
  {
    id: 14,
    title: '感恩的心',
    content: '感恩每一份遇见，珍惜每一次机会。心怀感恩，幸福常在。',
    theme: 'love',
    icon: '🙏'
  },
  {
    id: 15,
    title: '勇往直前',
    content: '不畏艰险，不惧挑战。勇往直前，无所畏惧。',
    theme: 'strength',
    icon: '⚡'
  },
  {
    id: 16,
    title: '内心平和',
    content: '放下执念，获得平静。内心平和，万事皆通。',
    theme: 'peace',
    icon: '🌊'
  },
  {
    id: 17,
    title: '持续进步',
    content: '日积月累，水滴石穿。持续进步，终成大器。',
    theme: 'growth',
    icon: '📈'
  },
  {
    id: 18,
    title: '绽放光彩',
    content: '展现真实的自己，绽放独特的光彩。你是独一无二的。',
    theme: 'success',
    icon: '🌺'
  }
];

export const getCardById = (id) => {
  return cards.find(card => card.id === id);
};

export const getCardsByTheme = (theme) => {
  return cards.filter(card => card.theme === theme);
};

export const getRandomCard = () => {
  const randomIndex = Math.floor(Math.random() * cards.length);
  return cards[randomIndex];
};

export const getMultipleRandomCards = (count) => {
  const shuffled = [...cards].sort(() => Math.random() - 0.5);
  return shuffled.slice(0, count);
};
